<template>
  <div class="animated fadeInRight padding">
    <el-card class="box-card">
      <div slot="header">
        <span>月卡申请审核</span>
      </div>
      <el-alert title="新月卡必须先审核并锁定真实车辆类型、月价和有效期；已付款不等于停车场已生效。"
        type="warning" :closable="false" show-icon class="notice" />
      <el-form :inline="true" :model="conditions">
        <el-form-item label="车牌号">
          <el-input v-model.trim="conditions.plateNumber" maxlength="8"
            placeholder="请输入完整车牌" clearable />
        </el-form-item>
        <el-form-item label="业务">
          <el-select v-model="conditions.orderType" clearable placeholder="全部">
            <el-option label="新卡申请" value="NEW" />
            <el-option label="已有卡续费" value="RENEW" />
          </el-select>
        </el-form-item>
        <el-form-item label="审核">
          <el-select v-model="conditions.reviewState" clearable placeholder="全部">
            <el-option label="待审核" value="PENDING" />
            <el-option label="已通过" value="APPROVED" />
            <el-option label="已拒绝" value="REJECTED" />
            <el-option label="无需审核" value="NOT_REQUIRED" />
          </el-select>
        </el-form-item>
        <el-form-item label="付款">
          <el-select v-model="conditions.paymentState" clearable placeholder="全部">
            <el-option label="不允许付款" value="NOT_ALLOWED" />
            <el-option label="待付款" value="CREATED" />
            <el-option label="支付中" value="PAYING" />
            <el-option label="已付款" value="PAID" />
            <el-option label="已取消" value="CANCELLED" />
          </el-select>
        </el-form-item>
        <el-form-item label="停车场">
          <el-select v-model="conditions.syncState" clearable placeholder="全部">
            <el-option label="待审核" value="WAITING_REVIEW" />
            <el-option label="待付款" value="WAITING_PAYMENT" />
            <el-option label="待下发" value="PENDING" />
            <el-option label="重试中" value="RETRY" />
            <el-option label="等待本地确认" value="WAITING_CHANGE" />
            <el-option label="已生效" value="COMPLETED" />
            <el-option label="无需下发" value="NOT_REQUIRED" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="queryOrders">查询</el-button>
          <el-button @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="box-card table-card">
      <el-table v-loading="loading" :data="orders" border style="width:100%">
        <el-table-column prop="orderId" label="订单号" min-width="220" />
        <el-table-column prop="communityName" label="小区" min-width="140" />
        <el-table-column prop="plateNumber" label="车牌" width="110" align="center" />
        <el-table-column prop="personName" label="车主" width="100" />
        <el-table-column label="业务" width="95" align="center">
          <template slot-scope="scope">
            {{ scope.row.orderType === 'NEW' ? '新卡申请' : '已有卡续费' }}
          </template>
        </el-table-column>
        <el-table-column label="期数" width="75" align="center">
          <template slot-scope="scope">{{ scope.row.months }}个月</template>
        </el-table-column>
        <el-table-column prop="authTypeName" label="真实车辆类型" min-width="120">
          <template slot-scope="scope">{{ scope.row.authTypeName || '-' }}</template>
        </el-table-column>
        <el-table-column label="月价/总额" width="125" align="right">
          <template slot-scope="scope">
            <div>月 ¥{{ centsToYuan(scope.row.monthlyPriceCents) }}</div>
            <div>总 ¥{{ centsToYuan(scope.row.totalAmountCents) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="有效期" min-width="180">
          <template slot-scope="scope">
            <div>{{ scope.row.beginTime || '-' }}</div>
            <div>至 {{ scope.row.endTime || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="物业审核" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="reviewTag(scope.row.reviewState)" size="small">
              {{ reviewText(scope.row.reviewState) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="付款状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="paymentTag(scope.row.paymentState)" size="small">
              {{ paymentText(scope.row.paymentState) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="停车场生效" width="125" align="center">
          <template slot-scope="scope">
            <el-tag :type="syncTag(scope.row.syncState)" size="small">
              {{ syncText(scope.row.syncState) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="错误/拒绝原因" min-width="170">
          <template slot-scope="scope">
            {{ scope.row.rejectReason || scope.row.lastError || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button v-if="scope.row.orderType === 'NEW' &&
              scope.row.reviewState === 'PENDING'"
              type="primary" size="mini" @click="openReview(scope.row)">
              审核
            </el-button>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination :current-page="pagination.current"
        :page-sizes="[10, 20, 30, 50]" :page-size="pagination.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" class="pagination" />
    </el-card>

    <el-dialog title="审核新月卡申请" :visible.sync="reviewVisible"
      width="560px" :close-on-click-modal="false">
      <el-form ref="reviewForm" :model="reviewForm" label-width="120px">
        <el-form-item label="车牌号">
          <strong>{{ reviewOrder.plateNumber }}</strong>
        </el-form-item>
        <el-form-item label="车主/联系电话">
          {{ reviewOrder.personName }} / {{ reviewOrder.personPhone }}
        </el-form-item>
        <el-form-item label="申请期数">
          {{ reviewOrder.months }}个月
        </el-form-item>
        <el-form-item label="真实车辆类型" prop="authType"
          :rules="[{ required: true, message: '请选择停车场返回的真实车辆类型', trigger: 'change' }]">
          <el-select v-model="reviewForm.authType" style="width:100%"
            placeholder="来自9.9接口3.5">
            <el-option v-for="item in authTypes" :key="item.authType"
              :label="`${item.authTypeName}（${item.authType}）`"
              :value="item.authType" />
          </el-select>
          <div class="tip">临时车（0）不能用于月卡，已从候选项中排除。</div>
        </el-form-item>
        <el-form-item label="真实月价（元）" prop="monthlyPrice"
          :rules="[{ required: true, message: '请填写真实月价', trigger: 'blur' }]">
          <el-input-number v-model="reviewForm.monthlyPrice"
            :precision="2" :step="1" :min="0.01" style="width:100%" />
          <div class="tip">新车不能通过3.6查价，请按停车场真实收费标准填写；审核后价格锁定。</div>
        </el-form-item>
        <el-form-item label="生效时间" prop="beginTime"
          :rules="[{ required: true, message: '请选择生效时间', trigger: 'change' }]">
          <el-date-picker v-model="reviewForm.beginTime" type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss" style="width:100%" />
        </el-form-item>
        <el-form-item label="拒绝原因">
          <el-input v-model.trim="reviewForm.rejectReason" type="textarea"
            maxlength="500" show-word-limit />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="reviewVisible = false">取消</el-button>
        <el-button type="danger" :loading="reviewing" @click="rejectReview">拒绝</el-button>
        <el-button type="primary" :loading="reviewing" @click="approveReview">通过并锁价</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  listParking99MonthOrders,
  listParking99MonthAuthTypes,
  reviewParking99MonthApplication
} from '@/api/fee/buyCarMonthCardApi'
import { getCommunityId } from '@/api/community/communityApi'

export default {
  name: 'BuyCarMonthCardList',
  data() {
    return {
      loading: false,
      reviewing: false,
      orders: [],
      authTypes: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      conditions: {
        plateNumber: '',
        orderType: '',
        reviewState: '',
        paymentState: '',
        syncState: ''
      },
      reviewVisible: false,
      reviewOrder: {},
      reviewForm: {
        authType: null,
        monthlyPrice: null,
        beginTime: '',
        rejectReason: ''
      }
    }
  },
  created() {
    if (this.$route.query.carNum) {
      this.conditions.plateNumber = this.$route.query.carNum
    }
    this.queryOrders()
  },
  methods: {
    async queryOrders() {
      this.loading = true
      try {
        const result = await listParking99MonthOrders({
          ...this.conditions,
          communityId: getCommunityId(),
          page: this.pagination.current,
          row: this.pagination.size
        })
        this.orders = result.data || []
        this.pagination.total = result.total || 0
      } catch (error) {
        this.$message.error(error.message || '查询月卡订单失败')
      } finally {
        this.loading = false
      }
    },
    resetQuery() {
      this.conditions = {
        plateNumber: '',
        orderType: '',
        reviewState: '',
        paymentState: '',
        syncState: ''
      }
      this.pagination.current = 1
      this.queryOrders()
    },
    async openReview(order) {
      this.reviewOrder = order
      this.reviewForm = {
        authType: null,
        monthlyPrice: null,
        beginTime: this.formatDate(new Date()),
        rejectReason: ''
      }
      try {
        const result = await listParking99MonthAuthTypes({
          communityId: order.communityId
        })
        this.authTypes = (result.data || []).filter(
          item => Number(item.authType) > 0
        )
        if (!this.authTypes.length) {
          throw new Error('停车场未返回可用于月卡的车辆类型')
        }
        this.reviewVisible = true
        this.$nextTick(() => this.$refs.reviewForm && this.$refs.reviewForm.clearValidate())
      } catch (error) {
        this.$message.error(error.message || '查询真实车辆类型失败')
      }
    },
    async approveReview() {
      await this.$refs.reviewForm.validate()
      if (Number(this.reviewForm.authType) <= 0) {
        this.$message.warning('临时车不能用于月卡，请重新选择车辆类型')
        return
      }
      this.reviewing = true
      try {
        await reviewParking99MonthApplication({
          orderId: this.reviewOrder.orderId,
          action: 'APPROVE',
          authType: this.reviewForm.authType,
          monthlyPrice: String(this.reviewForm.monthlyPrice),
          beginTime: this.reviewForm.beginTime
        })
        this.$message.success('审核通过，业主现在可以付款')
        this.reviewVisible = false
        this.queryOrders()
      } catch (error) {
        this.$message.error(error.message || '审核失败')
      } finally {
        this.reviewing = false
      }
    },
    async rejectReview() {
      if (!this.reviewForm.rejectReason) {
        this.$message.warning('请填写拒绝原因')
        return
      }
      this.reviewing = true
      try {
        await reviewParking99MonthApplication({
          orderId: this.reviewOrder.orderId,
          action: 'REJECT',
          rejectReason: this.reviewForm.rejectReason
        })
        this.$message.success('申请已拒绝')
        this.reviewVisible = false
        this.queryOrders()
      } catch (error) {
        this.$message.error(error.message || '拒绝申请失败')
      } finally {
        this.reviewing = false
      }
    },
    handleSizeChange(size) {
      this.pagination.size = size
      this.pagination.current = 1
      this.queryOrders()
    },
    handleCurrentChange(current) {
      this.pagination.current = current
      this.queryOrders()
    },
    centsToYuan(cents) {
      if (cents === null || cents === undefined) return '-'
      return (Number(cents) / 100).toFixed(2)
    },
    reviewText(state) {
      return {
        PENDING: '待审核',
        APPROVED: '已通过',
        REJECTED: '已拒绝',
        NOT_REQUIRED: '无需审核'
      }[state] || state
    },
    reviewTag(state) {
      return {
        APPROVED: 'success',
        REJECTED: 'danger',
        PENDING: 'warning',
        NOT_REQUIRED: 'info'
      }[state] || 'info'
    },
    paymentText(state) {
      return {
        NOT_ALLOWED: '不可付款',
        CREATED: '待付款',
        PAYING: '支付中',
        PAID: '已付款',
        CANCELLED: '已取消'
      }[state] || state
    },
    paymentTag(state) {
      return {
        PAID: 'success',
        PAYING: 'warning',
        CANCELLED: 'info',
        NOT_ALLOWED: 'info'
      }[state] || ''
    },
    syncText(state) {
      return {
        WAITING_REVIEW: '待审核',
        WAITING_PAYMENT: '待付款',
        PENDING: '待下发',
        PROCESSING: '下发中',
        RETRY: '重试中',
        WAITING_CHANGE: '等待本地确认',
        COMPLETED: '已生效',
        NOT_REQUIRED: '无需下发'
      }[state] || state
    },
    syncTag(state) {
      return {
        COMPLETED: 'success',
        RETRY: 'danger',
        WAITING_CHANGE: 'warning',
        PENDING: 'warning',
        PROCESSING: 'warning',
        NOT_REQUIRED: 'info'
      }[state] || 'info'
    },
    formatDate(date) {
      const pad = value => String(value).padStart(2, '0')
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ` +
        `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
    }
  }
}
</script>

<style scoped>
.notice {
  margin-bottom: 18px;
}

.table-card {
  margin-top: 20px;
}

.pagination {
  margin-top: 20px;
}

.tip {
  color: #909399;
  font-size: 12px;
  line-height: 18px;
  margin-top: 4px;
}
</style>
